import React, { useEffect, useState } from "react";
import "./TheoPlayer.scss"

const TheoPlayer = ({
    handleReadyStateChange,
    onTimeUpdate,
    onTargetQualityChanged,
    onPlay,
    onPause,
    onPlayerError,
    ...props
}) => {
    const [player, setPlayer] = useState()
    const [source, setSource] = useState(props.source)
    const _el = React.useRef();
    const _wrapper = React.useRef();

    const checkControlsVisible = () => {
        const current = _el?.current;
        if (!current) {
            return false;
        }
        return (current.classList.contains("vjs-user-active") || current.classList.contains("vjs-paused")) && current.classList.contains("vjs-has-started");
    }

    const updateTextTracksPosition = () => {
        const htmlCollection = document.getElementsByClassName("theoplayer-texttracks")
        if (checkControlsVisible()) {
            for (const element of htmlCollection) {
                element.classList.remove("bottom-0");
            }
        }
        else {
            for (const element of htmlCollection) {
                element.classList.add("bottom-0");
            }
        }
    }

    useEffect(() => {
        let _player = null
        if (!player) {
            _player = librariesLoaded()
        }
        else {
            _player = player
        }
        if (props.source && source !== props.source) {
            setSource(props.source)
        }
        _player.source = props.source
        window.setTimeout(() => {
            _player.play()
            const observer = new MutationObserver(function (event) {
                updateTextTracksPosition()
            })
            observer.observe(_el.current, {
                attributes: true,
                attributeFilter: ['class'],
                childList: false,
                characterData: false
            })
        }, 1)

    }, [props.source])

    const librariesLoaded = () => {

        if (_el.current) {
            const _player = new window.THEOplayer.Player(_el.current, {
                // libraryLocation: "/node_modules/theoplayer/",
                libraryLocation: `https://cdn.myth.theoplayer.com/${process.env.REACT_APP_THEO_API_KEY}`,
                license: process.env.REACT_APP_THEO_API_LICENSE,
                muted: true,
                fluid: true,
            });

            _player.preload = 'auto';
            _player.muted = true;
            _player.source = props.source
            _player.autoplay = true;
            _player.loop = true;

            if (handleReadyStateChange) {
                _player.addEventListener('readystatechange', (e) => handleReadyStateChange(e, _player))
            }
            if (onPlay) {
                _player.addEventListener('play', (e) => onPlay(e, _player))
            }
            if (onPause) {
                _player.addEventListener('pause', (e) => onPause(e, _player))
            }
            if (onTimeUpdate) {
                _player.addEventListener('timeupdate', (e) => onTimeUpdate(e, _player))
            }
            if (onTargetQualityChanged) {
                _player.addEventListener('targetqualitychanged', (e) => onTargetQualityChanged(e, _player))
            }
            if (onPlayerError) {
                _player.addEventListener('error', (e) => onPlayerError(e, _player))
            }

            setPlayer(_player)
            if (props.onPLayerReady) {
                props.onPLayerReady(_player)
            }
            return _player
        }
    }

    return (
        <div
            ref={_wrapper}
            className="player-wrapper">
            <div
                // vjs-16-9 THEOplayer are not necessary, but just added for demo purposes
                className={"theoplayer-container video-js theoplayer-skin vjs-16-9"}
                // The ref prop here is key it returns the actual dom element and not the virtual react dom elements
                // Which is need by the player
                ref={_el}
            />
        </div>
    );

}

export default TheoPlayer;